import { accountsTypes } from 'app-components/flux/accounts';
import { Record } from 'immutable';

export const DefaultAccountBalances = Record({
  accountId: null,
  accountType: null,

  balance: 0, // total display balance
  goalsBalance: 0, // amount contributed to goals out of this account
  availableBalance: 0, // amount left after removing goalsBalance (balance - goalsBalance)

  // if you need to add a new balance value, please consult with Chris

  earliestTransactionDate: null,
});

export type AccountBalances = {
  accountId: string;
  accountType: accountsTypes.AccountSubType | undefined;
  balance: number;
  goalsBalance: number;
  availableBalance: number;
  earliestTransactionDate?: string;
};

export const AccountBalancesRecord = Record<AccountBalances>({
  accountId: '',
  accountType: undefined,
  balance: 0,
  goalsBalance: 0,
  availableBalance: 0,
  earliestTransactionDate: undefined,
});

export const ShowBalance = Object.freeze({
  INCLUDE_PENDING: 'INCLUDE_PENDING',
  BANK_REPORTED: 'BANK_REPORTED',
});

export const visibleBalances = [
  { label: 'Bank Balance', key: 'balance', value: ShowBalance.BANK_REPORTED },
  { label: 'Balance with pending', key: 'balance', value: ShowBalance.INCLUDE_PENDING },
];
